/* @refresh reload */
import './assets/arc/arc.less';
import './assets/styles.less'
import './assets/index.css'
import './assets/Edit.css'
import { MountableElement, render } from 'solid-js/web';
import { App } from './app';
render(() => <App />, document.getElementById('root') as MountableElement);